import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Suppress console errors from failed image loads
const originalConsoleError = console.error;
console.error = (...args) => {
  // Suppress errors containing image load failures
  if (args.some(arg => typeof arg === 'string' && (
    arg.includes('Failed to load resource') ||
    arg.includes('ERR_CONNECTION_CLOSED') ||
    arg.includes('ERR_FAILED') ||
    arg.includes('CORS policy')
  ))) {
    return; // Suppress
  }
  originalConsoleError(...args);
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
